const baseRules = {
  name: [
    { required: true, message: '请输入资产名称', trigger: 'change' },
    { min: 2, max: 20, message: '请输入 2 到 20 个字符', trigger: 'blur' },
  ],
  tempAssetType: [{ required: true, message: '请选择资产类型', trigger: 'change' }],
  assetLocation: [
    // { required: true, message: '请输入资产位置', trigger: 'change' },
    { min: 2, max: 50, message: '请输入 2 到 50 个字符', trigger: 'blur' },
  ],
  selfOwnedFlag: [{ required: true, message: '请选择是否自有', trigger: 'change' }],
  selfUseFlag: [{ required: true, message: '请选择是否自用', trigger: 'change' }],
  leafFlag: [{ required: true, message: '请选择有子层级', trigger: 'change' }],
  rightParty: [
    { required: true, message: '请输入权力方', trigger: 'change' },
    { min: 2, max: 20, message: '请输入 2 到 20 个字符', trigger: 'blur' },
  ],
  area: [
    { required: true, message: '请输入面积', trigger: 'change' },
    {
      pattern: /^([1-9]\d*(\.\d*)?)|(0\.\d*[1-9][0-9])|(0\.\d*[1-9])$/,
      message: '请输入大于0的数字',
      trigger: 'blur',
    },
  ],
};

export { baseRules };
